
export class ReportClaimRequest {

    public customerFirstName = "";
    public customerLastName = "";
    public contractNumber = "";
    public vin = "";
    public breakdownDate: Date;
    public currentMileage: number;
    public causeOfFailure = "";
    public customerConcern = "";

    public repairFacilityName = "";
    public repairFacilityPhone = "";
    public repairFacilityBusinessEmail = "";
    public repairFacilityContactEmail = "";
    public repairFacilityContact = "";
    public repairFacilityPreferredContactMethod = ""
    
    public repairFacilityAddressLine1 = "";
    public repairFacilityAddressLine2 = "";
    public repairFacilityCity = "";
    public repairFacilityState = "";
    public repairFacilityZip = "";

    public repairFacilityLaborRatePerHour = "";
    public repairFacilityLaborManualUsed = "";
    public repairFacilityPreferredPayment = "";

}